import { useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { Modal } from "react-bootstrap";
import CustomSelect from "../../component/CustomSelect";
import { toast } from "react-toastify";
import Icons from "../../myIcon/Icons";

const tagEditEndpoint = ApiEndpoints.tags.tagEdit;
const tagUpdateEndPoint = ApiEndpoints.tags.tagUpdate;

export default function EditTags({ show, onHide, tagId }) {
  const tags_id = tagId;
  const [data, setData] = useState({ name: "" , slug: "", status: "" });
  const StatusData = [{ _id: "1", name: "Disable" }, { _id: "0", name: "Enable" }];

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest(
          "GET",
          `${tagEditEndpoint}${tags_id}`
        );
        const result = response.tag;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, [tags_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
      event.preventDefault();
      if (!data.name || !data.status) {
        alert("All fields are required.");
        return;
      }
      const payload = {
        tag_id: tags_id,
        name: data.name,
        slug:data.slug,
        status: data.status,
      };

      try {
        const response = await ApiRequest("POST", tagUpdateEndPoint, payload);
        toast.success(response.message);
        onHide();
      } catch (error) {
        console.error("Error updating tag data:", error);
      }
    };

  return (
    <>
      <Modal className="add-modal-area" show={show} onHide={onHide} size="sm" aria-labelledby="contained-modal-title-vcenter" centered >
        <Modal.Body>
          <button className="modal-close-button" onClick={onHide}><Icons name="cross"/></button>
          <form onSubmit={handleSubmit}>
            <div className="add-page-inputs">
              <div className="col-lg-12">
                <div className="add-page-sections">Edit Tag</div>
              </div>
              <div className="label-wrap-add">
                <label>Enter Name<small>*</small></label>
              </div>
              <input name="name" value={data.name} type="text" className="form-control" onChange={handleInputChange} required />
            </div>

            <div className="add-page-inputs">
              <div className="label-wrap-add">
                <label>Enter Slug<small>*</small></label>
              </div>
              <input name="slug" value={data.slug} type="text" className="form-control" onChange={handleInputChange} required />
            </div>

            <div className="add-page-inputs">
              <div className="label-wrap-add">
                <label>Status<small>*</small></label>
              </div>
              <CustomSelect name={"status"} defaultValue={data.status} options={StatusData} placeholder="Select Status" onChange={handleInputChange} />
            </div>

            <button type="submit" className="default-btn">Save Changes<span></span></button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
